import(/* webpackMode: "eager", webpackExports: ["InstallationGuideTabs"] */ "/codebuild/output/src955237198/src/esimify/src/app/[lang]/installation-guide/guide-tabs.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src955237198/src/esimify/src/components/layout/footer/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src955237198/src/esimify/src/components/layout/navigation/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src955237198/src/esimify/src/i18n/translation-provider.tsx");
